import INITIAL_STATE from "./init";

export default (state = INITIAL_STATE, action) => {
  const matches = /(.*)_(REQUEST|ERROR)/.exec(action.type);
  if (!matches) return state;

  const [, label, status] = matches;

  if (state[label] && status === "REQUEST") {
    const updated = { ...state };
    delete updated[label];
    return updated;
  } else if (status === "ERROR")
    return {
      ...state,
      [label]: action.payload,
    };
  else return state;
};
